import { render, staticRenderFns } from "./BrandSidebar.vue?vue&type=template&id=a12e1910&"
import script from "./BrandSidebar.vue?vue&type=script&lang=js&"
export * from "./BrandSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a12e1910')) {
      api.createRecord('a12e1910', component.options)
    } else {
      api.reload('a12e1910', component.options)
    }
    module.hot.accept("./BrandSidebar.vue?vue&type=template&id=a12e1910&", function () {
      api.rerender('a12e1910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/brand/BrandSidebar.vue"
export default component.exports